import { ArnIfComponent } from '../if/ArnIfComponent';
import {
  ArnAuthContext,
  ArnAuthStatus,
  ArnConnectionStatus,
} from '@arianee/arn-client';
import { Subscription } from 'rxjs';

/**
 * An if, specialized for connection status.
 */
export class ArnIfConnectedComponent extends ArnIfComponent {
  protected context: ArnAuthContext | undefined;
  private statusSub: Subscription | undefined;

  protected authSubscription: Subscription | undefined;

  protected subscribeToAuth(): Subscription {
    return this.arnClient.auth.currentContext$.subscribe(
      (newContext: ArnAuthContext | undefined) => {
        this.context = newContext;
        if (newContext) {
          if (this.statusSub) {
            this.statusSub.unsubscribe();
          }
          this.statusSub = newContext.status$.subscribe(
            (newStatus: ArnAuthStatus) => {
              this.updateStatus(newStatus);
            }
          );
          this.updateStatus(newContext.status);
        } else {
          this.updateStatus(ArnAuthContext.DEFAULT_STATUS);
        }
      }
    );
  }

  override connectedCallback() {
    super.connectedCallback();
    this.authSubscription = this.subscribeToAuth();
  }

  protected override setInitial() {
    this.updateStatus(
      this.arnClient.auth.currentContext?.status ||
        ArnAuthContext.DEFAULT_STATUS
    );
  }

  disconnectedCallback() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  static override get observedAttributes() {
    return []; // No need to observe the "condition" attr here
  }

  override attributeChangedCallback(
    _name: string,
    _oldValue: string | null,
    _newValue: string | null
  ) {
    // We don't observe any attribute in this component.
  }

  protected updateStatus(status: ArnAuthStatus) {
    this.log.debug('updateStatus', status);
    const connected =
      status.connectionStatus === ArnConnectionStatus.authenticated;
    this.updateUI(connected);
  }
}

const name = 'arn-if-connected';
if (!window.customElements.get(name)) {
  window.customElements.define(name, ArnIfConnectedComponent);
}
